import script from "./InputBox.vue?vue&type=script&setup=true&lang=js"
export * from "./InputBox.vue?vue&type=script&setup=true&lang=js"

import "./InputBox.vue?vue&type=style&index=0&id=356ef12a&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\karuizawa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356ef12a"]])

export default __exports__